/*
 * @Description: 
 * @Author: 罗非
 * @Date: 2019-05-13 10:36:50
 * @LastEditTime: 2020-04-01 21:25:48
 * @LastEditors: DOJO
 */
import Vue from 'vue'
import { Toast } from '@yunji/h5'
import { InfiniteScroll } from 'mint-ui'
import VConsole from 'vconsole'
import App from '@/App.vue'
import router from './router'
import * as Http from './js/ajax'
import YunJi from '@/common/js/YunJi'
import wxShare from '@/common/js/wxShare'
import './css/reset.css'


//  本地环境及测试环境增加vconsole
if (window.location.hostname.search(/(v.|t.|txst.)/) === 0) {
  const vConsole = new VConsole()
}

Vue.use(InfiniteScroll)
Vue.config.productionTip = false
Vue.prototype.AJAX = Http
Vue.prototype.YunJi = YunJi
Vue.prototype.Toast = Toast
Vue.prototype.wxShare = wxShare
Vue.filter('filterFormatDate', YunJi.filterFormatDate)
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
